import { Dialog, DialogType } from '../../../../src/feature/narrator/narrator.model';

export const dialog: Dialog[] = [
  {
    id: 'start',
    type: DialogType.description,
    text: 'A townswoman pauses with her basket and looks you over, curious.',
    options: [
      { text: 'Greet her.', nextDialogId: 'greet' },
      { text: 'Ask what news there is.', nextDialogId: 'news' },
    ],
  },
  {
    id: 'greet',
    type: DialogType.dialog,
    text: 'Welcome, traveller. A new face. We like a new face. It gives us something to talk about.',
    options: [
      { text: 'What do folk talk about?', nextDialogId: 'news' },
      { text: 'A quiet town, then?', nextDialogId: 'quiet' },
    ],
  },
  {
    id: 'news',
    type: DialogType.dialog,
    text: 'They say in the market that the count cares only for Prague now, and the Roman crown. And that the land will pass to his young brother one day.',
    options: [
      { text: 'His brother?', nextDialogId: 'heir' },
      { text: 'Only market talk?', nextDialogId: 'quiet' },
    ],
  },
  {
    id: 'heir',
    type: DialogType.dialog,
    text: "Wenceslaus, they call him. Still a boy, they say. Lords' business. It changes little for the likes of us.",
    options: [{ text: 'True enough.', nextDialogId: 'bye' }],
  },
  {
    id: 'quiet',
    type: DialogType.dialog,
    text: 'Quiet enough. The well, the church, the market. A wedding when we are lucky. It suits me well.',
    options: [{ text: 'Sounds peaceful.', nextDialogId: 'bye' }],
  },
  {
    id: 'bye',
    type: DialogType.dialog,
    text: 'Go well, traveller. Mind how you go.',
    options: [{ text: 'Leave.', nextDialogId: 'start' }],
  },
];
